import { useCallback, useEffect, useState } from 'react';
import { userManagementApi } from '../api/userManagementApi';
import { UserAccessProfile } from '../models/userManagement';

interface UseUserProfileResult {
  profile: UserAccessProfile | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useUserProfile = (): UseUserProfileResult => {
  const [profile, setProfile] = useState<UserAccessProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await userManagementApi.getCurrentUserProfile();
      setProfile(response);
    } catch (err) {
      console.error('[useUserProfile] Failed to fetch profile', err);
      const message = err instanceof Error ? err.message : 'Unable to load profile';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { profile, loading, error, refresh };
};
